import theme from "app/Theme/Theme";
import React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

const WisdomBadge = ({ size }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 145 145">
      <G
        id="badges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G id="1-copy-115" transform="translate(-116.000000, -240.000000)">
          <G id="Group-5" transform="translate(119.000000, 243.000000)">
            <Circle
              id="Oval"
              stroke="#FFE66D"
              strokeWidth="6"
              fill="#33BBFF"
              cx="69.5"
              cy="69.5"
              r="69.5"
            />
            <G
              id="parchment"
              transform="translate(28.000000, 31.000000)"
              fillRule="nonzero"
            >
              <Path
                d="M82.755478,6 L15.2438762,6 C14.5567089,6 14,6.55805476 14,7.24688327 L14,70.7531167 C14,71.4419452 14.5567089,72 15.2438762,72 L82.755478,72 C83.4426453,72 84,71.4419452 84,70.7531167 L84,7.24688327 C84,6.55805476 83.4426453,6 82.755478,6 Z"
                id="Path"
                fill="#F9E075"
              ></Path>
              <Path
                d="M15.7655815,5 L1.23441862,5 C0.552189398,5 0,5.54899906 0,6.22664976 L0,67.7387367 C0,71.2499099 3.7333635,74 8.5,74 C13.265996,74 17,71.2499099 17,67.7387367 L17,6.22664976 C17,5.54899906 16.4471702,5 15.7655815,5 Z"
                id="Path"
                fill="#F9CD45"
              ></Path>
              <Path
                d="M8.5,0 C3.7333635,0 0,2.85509393 0,6.4996695 C0,10.1449062 3.7333635,13 8.5,13 C13.265996,13 17,10.1449062 17,6.4996695 C17,2.85509393 13.265996,0 8.5,0 Z"
                id="Path"
                fill="#F8B53C"
              ></Path>
              <G
                id="Group"
                transform="translate(22.000000, 17.000000)"
                fill="#F9CD45"
              >
                <Path
                  d="M14.8898648,2.52270158 L1.33984383,2.52270158 C0.656433597,2.52270158 0.102126195,1.9852808 0.102126195,1.32269022 C0.102126195,0.660099638 0.656433597,0.12330171 1.33984383,0.12330171 L14.8898648,0.12330171 C15.5739173,0.12330171 16.1275823,0.660099638 16.1275823,1.32269022 C16.1275823,1.9852808 15.5739173,2.52270158 14.8898648,2.52270158 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M47.7160366,10.8156703 L1.33984383,10.8156703 C0.656433597,10.8156703 0.102126195,10.2788722 0.102126195,9.61628162 C0.102126195,8.95369104 0.656433597,8.41627042 1.33984383,8.41627042 L47.7160366,8.41627042 C48.3994468,8.41627042 48.9531119,8.95369104 48.9531119,9.61628162 C48.9531119,10.2788722 48.3994468,10.8156703 47.7160366,10.8156703 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M47.7160366,19.108639 L1.33984383,19.108639 C0.656433597,19.108639 0.102126195,18.5718411 0.102126195,17.9092505 C0.102126195,17.2466599 0.656433597,16.7092391 1.33984383,16.7092391 L47.7160366,16.7092391 C48.3994468,16.7092391 48.9531119,17.2466599 48.9531119,17.9092505 C48.9531119,18.5718411 48.3994468,19.108639 47.7160366,19.108639 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M47.7160366,27.4022306 L1.33984383,27.4022306 C0.656433597,27.4022306 0.102126195,26.8648098 0.102126195,26.2022192 C0.102126195,25.5396286 0.656433597,25.0028307 1.33984383,25.0028307 L47.7160366,25.0028307 C48.3994468,25.0028307 48.9531119,25.5396286 48.9531119,26.2022192 C48.9531119,26.8648098 48.3994468,27.4022306 47.7160366,27.4022306 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M47.7160366,35.6951993 L1.33984383,35.6951993 C0.656433597,35.6951993 0.102126195,35.1577785 0.102126195,34.4951879 C0.102126195,33.8325973 0.656433597,33.2957994 1.33984383,33.2957994 L47.7160366,33.2957994 C48.3994468,33.2957994 48.9531119,33.8325973 48.9531119,34.4951879 C48.9531119,35.1577785 48.3994468,35.6951993 47.7160366,35.6951993 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M31.9372248,43.988168 L22.133114,43.988168 C21.4497038,43.988168 20.8953964,43.4513701 20.8953964,42.7887795 C20.8953964,42.1261889 21.4497038,41.5887681 22.133114,41.5887681 L31.9372248,41.5887681 C32.620635,41.5887681 33.1743,42.1261889 33.1743,42.7887795 C33.1743,43.4513701 32.620635,43.988168 31.9372248,43.988168 Z"
                  id="Path"
                ></Path>
              </G>
              <G
                id="Group-4"
                transform="translate(66.000000, 48.500000) rotate(13.000000) translate(-66.000000, -48.500000) translate(58.000000, 14.000000)"
              >
                <Path
                  d="M14.5415084,20.6589091 C14.4453918,20.1665133 14.1198357,19.7641666 13.6696379,19.5840684 C13.4705836,19.5042378 13.1251839,19.3662903 12.3791954,19.6134462 C13.1326254,17.1386943 13.4296565,15.545912 13.2628478,14.8625613 C11.3696612,7.11834436 9.14347716,0.867280694 9.12115331,0.805332108 C8.94814343,0.321238797 8.50042628,0 8,0 C7.49957356,0 7.05185641,0.321238797 6.87884653,0.805332108 C6.59793811,1.59022772 0,20.1882273 0,33.6010629 C0,40.1695334 0.724905003,46.3605641 2.04077206,51.0335342 C3.50794506,56.2448826 5.56856055,59 8,59 C10.4314393,59 12.4920548,56.2448826 13.9592279,51.0335342 C15.2750948,46.3605641 16,40.1695334 16,33.6010629 C16,29.9761103 15.5094954,25.6218244 14.5415084,20.6589091 L14.5415084,20.6589091 Z"
                  id="Path"
                  fill={theme.colors["neutral.white"]}
                ></Path>
                <Path
                  d="M14.3686235,20.6589091 C14.2611135,20.1665133 13.896967,19.7641666 13.3934043,19.5840684 C13.1707547,19.5042378 12.7844125,19.3662903 11.9499968,19.6134462 C12.792736,17.1386943 13.1249762,15.545912 12.9383945,14.8625613 C10.8207957,7.11834436 8.33072693,0.867280694 8.30575688,0.805332108 C8.11223896,0.321238797 7.61145086,0 7.05170556,0 C6.49196026,0 5.99117216,0.321238797 5.79765424,0.805332108 C5.7407781,0.949027336 5.44460554,1.69432684 5,2.89498064 C5.91001954,5.36845515 7.45469453,9.79554687 8.84053213,14.8625613 C9.02711384,15.545912 8.69487343,17.1386943 7.85213442,19.6134462 C8.68655025,19.3662903 9.07289235,19.5042378 9.2955419,19.5840684 C9.79910446,19.7641666 10.1632511,20.1665133 10.2707609,20.6589091 C11.3534901,25.6218244 11.9021374,29.9754717 11.9021374,33.6010629 C11.9021374,40.1695334 11.0913045,46.3605641 9.61945896,51.0335342 C8.40841152,54.878181 6.83599204,57.3842265 5.00277445,58.4347987 C5.65407641,58.8084063 6.33867195,59 7.05170556,59 C9.77135996,59 12.0762342,56.2448826 13.7173214,51.0335342 C15.1891669,46.3605641 16,40.1695334 16,33.6010629 C16,29.9761103 15.4513525,25.6218244 14.3686235,20.6589091 L14.3686235,20.6589091 Z"
                  id="Path"
                  fill="#E9E8EE"
                ></Path>
                <Path
                  d="M7.49961062,69 C6.67116524,69 6,68.4346703 6,67.7376705 L6,35.2623295 C6,34.5653297 6.67116524,34 7.49961062,34 C8.32883456,34 9,34.5653297 9,35.2623295 L9,67.7376705 C9,68.4346703 8.32883456,69 7.49961062,69 Z"
                  id="Path"
                  fill="#E9E8EE"
                ></Path>
              </G>
              <Path
                d="M82.7702616,6 L79,6 C79.6796427,6 80.2297384,6.55805476 80.2297384,7.24688327 L80.2297384,70.7531167 C80.2297384,71.4419452 79.6796427,72 79,72 L82.7702616,72 C83.4499042,72 84,71.4419452 84,70.7531167 L84,7.24688327 C84,6.55805476 83.4492661,6 82.7702616,6 Z"
                id="Path"
                fill="#F9CD45"
              ></Path>
              <Path
                d="M16.6933984,5 L12.6874808,5 C13.4096037,5 13.9940826,5.54899906 13.9940826,6.22664976 L13.9940826,67.7387367 C13.9940826,70.7690581 11.0493128,73.2306372 7,73.8484202 C7.64279111,73.9465013 8.31202602,74 9.0029587,74 C14.0483266,74 18,71.2499099 18,67.7387367 L18,6.22664976 C18,5.54899906 17.4148432,5 16.6933984,5 Z"
                id="Path"
                fill="#F8B53C"
              ></Path>
              <Path
                d="M9.0029587,0 C8.31202602,0 7.6421131,0.0555414274 7,0.157367462 C11.0493128,0.798738622 13.9940826,3.35430545 13.9940826,6.4996695 C13.9940826,9.64503339 11.0493128,12.2012614 7,12.8426327 C7.6421131,12.9444586 8.31202602,13 9.0029587,13 C14.0476484,13 18,10.1449062 18,6.4996695 C18,2.85509393 14.0476484,0 9.0029587,0 Z"
                id="Path"
                fill="#F8A814"
              ></Path>
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};

WisdomBadge.defaultProps = {
  size: 145,
};

export default WisdomBadge;
